export default __webpack_public_path__ + "static/hand-070175fb00e75f91af33b21e05d1da2b.svg";